import { ReactNode, ReactElement } from 'react'
import { Flex } from 'theme-ui'

export default function BaseHeader({ children }: { children: ReactNode }): ReactElement {
  return (
    <Flex
      sx={{
        mt: ['4.8rem', '8rem', '8rem'],
        flexDirection: 'column',
        gap: ['3.2rem', '4.8rem'],
        maxWidth: '98rem',
        alignItems: 'center',
        width: '100%',
        px: ['1.6rem', '1.6rem', 0],
      }}
    >
      {children}
    </Flex>
  )
}
